export default __webpack_public_path__ + "static/media/JPstreet-day.515d9058.jpg";